import Entity from './entity'
export default class Smokeleaf extends Entity<number>{
    yieldly:string;
    year:string;
    grade:string;
    title:string;
    ftId:Number;
    wId:Number;
    fId:Number;
    comeTime: DateTime;
    outTime: DateTime;
}